// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SafariOutlinedSvg from "@fishx/icons-svg/es/asn/SafariOutlined";
import FishxIcon from '../components/FishxIcon';

var SafariOutlined = function SafariOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SafariOutlinedSvg
  }));
};

SafariOutlined.displayName = 'SafariOutlined';
export default React.forwardRef(SafariOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SafariOutlined.js
// module id = 4043
// module chunks = 0